import { useState } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "../details.css";
import CustomPagination from "../../../constants/CustomPagination";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import millify from "millify";

const Bonds = (props) => {
  const bonds = props.data;
  const t = props.t;
  const [page, setPage] = useState(1);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const stoqqyLang = window.localStorage.getItem("stoqqyLang");

  return (
    <>
      {bonds ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: isDesktopOrLaptop ? "98px" : "0px",
              paddingRight: isDesktopOrLaptop ? "98px" : "0px",
              marginTop: "19px",
            }}
          >
            <div
              style={{
                maxWidth: "100%",
                overflowX: "scroll",
              }}
            >
              <div
                style={{
                  height:
                    (bonds?.slice((page - 1) * 16, page * 16)?.length + 2) * 41,
                  width: 1500,
                }}
                className="ag-theme-alpine invisible-scrollbar"
              >
                <AgGridReact
                  defaultColDef={{
                    sortable: true,
                    filter: true,
                  }}
                  rowData={bonds?.slice((page - 1) * 16, page * 16)}
                  rowSelection={"single"}
                >
                  {/* <AgGridColumn
                    field={stoqqyLang === "it" ? "isin_scorta" : "isin_stock"}
                    filter="agTextColumnFilter"
                    width={160}
                  /> */}
                  <AgGridColumn
                    field={"isin_bond"}
                    filter="agTextColumnFilter"
                    width={160}
                    headerName={t("isin_bond")}
                  />
                  <AgGridColumn
                    field={"issuer"}
                    filter="agTextColumnFilter"
                    width={200}
                    headerName={t("issuer")}
                  />
                  <AgGridColumn
                    field={"name"}
                    filter="agTextColumnFilter"
                    width={200}
                    headerName={t("name")}
                  />
                  <AgGridColumn
                    field={"country"}
                    filter="agTextColumnFilter"
                    width={140}
                    headerName={t("country")}
                  />
                  <AgGridColumn
                    field={"issue_volume"}
                    headerName={t("issue_volume")}
                    filter="agTextColumnFilter"
                    width={160}
                    valueGetter={(params) => {
                      {
                        return millify(
                          params.data.issue_volume
                            ? params.data.issue_volume
                            : 0,
                          {
                            space: true,
                          }
                        );
                      }
                    }}
                  />
                  <AgGridColumn
                    field={"currency"}
                    filter="agTextColumnFilter"
                    width={140}
                    headerName={t("currency")}
                  />
                  <AgGridColumn
                    field={"coupon"}
                    filter="agTextColumnFilter"
                    width={140}
                    headerName={t("coupon")}
                  />
                  <AgGridColumn
                    field={"maturity_date"}
                    filter="agTextColumnFilter"
                    width={160}
                    headerName={t("maturity_date")}
                  />
                </AgGridReact>
              </div>
            </div>
          </div>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <CustomPagination
              page={page}
              totalPages={Math.ceil(bonds?.length / 16)}
              setPage={setPage}
              margin="40px"
              marginBottom="30px"
            />
          </div>{" "}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "5vh",
          }}
        >
          <CircularProgress
            style={{
              color: "#808080",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Bonds;
